import { buildSudokuData, setDataFunctions } from "./sudoku";
import { Obstacles } from "./obstacles";
import _ from 'lodash';
import { ItemStrings } from "./inventory";

const hyruleFieldGivens = [
    0, 8, 4, 0, 7, 0, 9, 0, 0,
    0, 3, 0, 0, 0, 1, 4, 0, 0,
    9, 2, 0, 3, 0, 6, 0, 0, 5,
    0, 4, 9, 0, 1, 0, 0, 5, 0,
    0, 0, 1, 6, 0, 0, 0, 0, 0,
    0, 0, 0, 4, 0, 8, 2, 9, 0, 
    5, 7, 2, 1, 0, 0, 0, 0, 6,
    0, 0, 8, 0, 0, 0, 0, 0, 2,
    4, 0, 6, 8, 0, 7, 5, 0, 0
]

const hyruleFieldSolution = [
    1, 8, 4, 2, 7, 5, 9, 6, 3,
    6, 3, 5, 9, 8, 1, 4, 2, 7,
    9, 2, 7, 3, 4, 6, 1, 8, 5,
    2, 4, 9, 7, 1, 3, 6, 5, 8, 
    8, 5, 1, 6, 9, 2, 3, 7, 4, 
    7, 6, 3, 4, 5, 8, 2, 9, 1, 
    5, 7, 2, 1, 3, 9, 8, 4, 6, 
    3, 9, 8, 5, 6, 4, 7, 1, 2, 
    4, 1, 6, 8, 2, 7, 5, 3, 9
]

const hyruleFieldPostProcess = function(data) {
    data.getCell(3, 5).obstacle = Obstacles.ancient;
    data.getCell(9, 7).obstacle = Obstacles.boulder;
    data.getCell(1, 9).obstacle = Obstacles.boulder;
}

export function buildHyruleField() {
    var data = {
        requiredItem: '',
        sudokuHistory: [buildSudokuData(hyruleFieldPostProcess, hyruleFieldGivens)],
        historyStep: 0,
        saveState: buildSudokuData(hyruleFieldPostProcess, hyruleFieldGivens),
        solution: hyruleFieldSolution,
        prizes: ['items.bow', 'songs.nocturneOfShadow', 'a Gold Skulltula', '20 Rupees', 'a Heart Piece', 'a Gold Skulltula', 'a Heart Piece', 'songs.serenadeOfWater', '5 Rupees'],
        solvedRegions: [],
        rules: [
            'Standard sudoku rules apply.',
            'Solving one of the 3x3 "regions" in any temple will open a chest, granting you an item or song.',
            'There are various obstacles blocking clues that you need to progress.',
            'Once you have the required item, click on an obstacle to remove it.',
            'Be sure to check the rules in each temple, as they will change.',
            'Completing all regions in a temple will grant you that temple\'s medallion. Collect all 6 medallions to finish the puzzle.'
        ],
        showHint: 0,
        hints: [

        ],
        notes: ''
    }
    setDefaultFunctions(data);
    return data;
}

export function setDefaultFunctions(data) {
    data.applyChanges = applyChanges;
    data.undo = undo;
    data.redo = redo;
    data.setSaveState = setSaveState;
    data.restoreSaveState = restoreSaveState;
    data.checkSolvedCell = checkSolvedCell;
    data.checkSolvedRegions = checkSolvedRegions;
    data.awardPrize = awardPrize;
    data.showNextHint = showNextHint;
    data.resetInitialState = resetInitialState;
    data.clearSelections =  clearSelections;
    data.getRegionCells = getRegionCells;
}

export function setDefaultDataFunctions(data) {
    for(var i = 0; i < data.sudokuHistory.length; i++) {
        setDataFunctions(data.sudokuHistory[i])
    }
    setDataFunctions(data.saveState);
}

const fireTempleGivens = [
    4, 0, 0, 0, 0, 0, 0, 7, 0, 
    1, 7, 0, 0, 6, 0, 0, 4, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 9, 0, 0, 0, 0, 0, 0, 
    0, 4, 2, 0, 3, 0, 0, 1, 0, 
    0, 0, 0, 0, 0, 0, 0, 5, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 3, 0, 0, 5, 0, 0, 9, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 
]

const fireTempleSolution = [
    4, 2, 5, 9, 1, 3, 6, 7, 8, 
    1, 7, 3, 2, 6, 8, 9, 4, 5, 
    9, 8, 6, 5, 7, 4, 3, 2, 1, 
    5, 1, 9, 7, 4, 2, 8, 6, 3, 
    8, 4, 2, 6, 3, 5, 7, 1, 9, 
    3, 6, 7, 1, 8, 9, 4, 5, 2, 
    7, 5, 1, 8, 9, 6, 2, 3, 4, 
    2, 3, 8, 4, 5, 7, 1, 9, 6, 
    6, 9, 4, 3, 2, 1, 5, 8, 7
]

/* eslint-disable no-unused-vars */
const fireTemplePostProcess = function(data) {
    data.getCell(3, 5).obstacle = Obstacles.heavySwitch;
    data.getCell(1, 1).obstacle = Obstacles.lava;
    data.getCell(1, 2).obstacle = Obstacles.lava;
}

export function buildFireTemple() {
    var data = {
        requiredItem: ItemStrings.boleroOfFire,
        sudokuHistory: [buildSudokuData(fireTemplePostProcess, fireTempleGivens)],
        historyStep: 0,
        saveState: buildSudokuData(fireTemplePostProcess, fireTempleGivens),
        solution: fireTempleSolution,
        prizes: ['a Heart Piece', '1 Rupee', 'a Heart Piece', '10 Rupees', 'items.hookshot', '5 Rupees', 'a Gold Skulltula', 'items.silverGauntlets', 'a Heart Piece'],
        solvedRegions: [],
        rules: [
            'Standard sudoku rules apply.',
            'In the center of each region is a Goron trapped in a prison locked with an 8-digit combination. You know a few of the combinations already.',
            'The 8 digits of a combination go clockwise around the prison in order. For example, the combination 12345678 could look like any of the following: <br /> <img src="images/fire-hint.png"/>',
        ],
        hints: [
            'Each combination will be missing one of the digits 1-9, which must be the center of the region it belongs to.',
            'You can remove possible cell values using standard sudoku rules. This will help narrow down possible positions for a prison combination.'
        ],
        showHint: 0,
        notes: ''
    }
    setDefaultFunctions(data);
    return data;
}

const shadowTempleGivens = [
    0, 9, 1, 2, 5, 0, 4, 8, 0,
    0, 0, 0, 0, 9, 0, 2, 1, 7,
    5, 0, 3, 8, 0, 4, 6, 0, 0,
    7, 4, 0, 0, 0, 9, 1, 6, 0,
    0, 6, 8, 1, 0, 5, 0, 3, 0,
    3, 0, 0, 7, 0, 0, 0, 0, 5,
    0, 0, 7, 9, 0, 0, 0, 5, 1,
    0, 3, 6, 0, 0, 0, 0, 2, 4,
    0, 0, 9, 4, 0, 8, 0, 7, 0,
]

const shadowTempleSolution = [
    2, 9, 1, 6, 5, 7, 4, 8, 3, 
    6, 8, 4, 3, 9, 2, 5, 1, 7, 
    5, 7, 3, 8, 1, 4, 6, 2, 9, 
    7, 4, 5, 2, 3, 9, 1, 6, 8, 
    9, 6, 8, 1, 4, 5, 7, 3, 2, 
    3, 1, 2, 7, 8, 6, 9, 4, 5, 
    4, 2, 7, 9, 6, 3, 8, 5, 1, 
    8, 3, 6, 5, 7, 1, 2, 9, 4, 
    1, 5, 9, 4, 2, 8, 3, 7, 6
]

const shadowTemplePostProcess = function(data) {
    data.getCell(4, 1).obstacle = Obstacles.illusion;
    data.getCell(6, 9).obstacle = Obstacles.void;
}

const getShadowTempleGivens = function() {
    var givens = [
        [], [], [], [], [], [], [], [], []
    ]

    for(var i = 0; i < shadowTempleGivens.length; i++) {
        if(shadowTempleGivens[i] != 0)
            givens[shadowTempleGivens[i] - 1].push(i);
    }
    return givens;
}

export function buildShadowTemple() {
    var data = {
        requiredItem: ItemStrings.nocturneOfShadow,
        sudokuHistory: [buildSudokuData(shadowTemplePostProcess, shadowTempleGivens)],
        historyStep: 0,
        saveState: buildSudokuData(shadowTemplePostProcess, shadowTempleGivens),
        solution: shadowTempleSolution,
        prizes: ['items.ironBoots', 'a Heart Piece', 'songs.minuetOfForest', '10 Rupees', 'a Gold Skulltula', 'a Gold Skulltula', 'a Gold Skulltula', 'items.mirrorShield', 'a Heart Piece'],
        solvedRegions: [],
        givens: getShadowTempleGivens(),
        rules: [
            'Standard sudoku rules apply.',
            'For one of the digits 1-9, ALL of its given clues must be false.'
        ],
        hints: [
            'There\'s already a contradiction on the board that should help narrow down which digits could be fake.',
            'Remember that the real answer for a cell cannot be what the fake clue was!',
            'The Lens of Truth still seems to be hiding something...'
        ],
        showHint: 0,
        notes: 'Dampe was here'
    }
    setShadowFunctions(data);
    return data;
}

export function setShadowFunctions(data) {
    setDefaultFunctions(data);
    data.toggleGivens = function(digit) {
        var newData = _.cloneDeep(this.sudokuHistory[this.historyStep]);
        var givens = this.givens[digit - 1];
        for(var i = 0; i < givens.length; i++) {
            var g = newData.cells[givens[i]];
            if(g.isGiven) {
                g.isGiven = false;
                if(g.conflictNumber) {
                    g.conflictNumber = 0;
                } else {
                    g.number = 0;
                }
            } else {
                g.isGiven = true;
                if(g.number != 0) {
                    g.conflictNumber = digit;
                } else {
                    g.number = digit;
                }
            }
        }
        return newData;
    };
}

const forestTempleGivens = [
    0, 1, 0, 7, 1, 8, 6, 0, 0, 
    0, 5, 0, 0, 9, 6, 7, 0, 0, 
    0, 8, 0, 2, 5, 0, 0, 0, 8, 
    2, 0, 3, 0, 6, 0, 0, 9, 0, 
    8, 4, 0, 9, 0, 5, 1, 3, 6, 
    0, 6, 9, 0, 3, 0, 0, 7, 2, 
    9, 0, 4, 0, 7, 2, 9, 0, 5, 
    3, 0, 1, 6, 8, 9, 3, 2, 0, 
    0, 0, 6, 0, 4, 1, 7, 0, 0
]

const forestTempleSolution = [
    6, 3, 2, 7, 1, 8, 9, 4, 5, 
    7, 1, 5, 4, 9, 6, 3, 2, 8, 
    4, 9, 8, 2, 5, 3, 7, 6, 1, 
    2, 5, 3, 1, 6, 7, 8, 9, 4, 
    8, 4, 7, 9, 2, 5, 1, 3, 6, 
    1, 6, 9, 8, 3, 4, 5, 7, 2, 
    9, 8, 4, 5, 7, 2, 6, 1, 3, 
    3, 2, 1, 6, 8, 9, 4, 5, 7, 
    5, 7, 6, 3, 4, 1, 2, 8, 9
]

const forestTemplePostProcess = function(data) {
    data.getCell(2, 1).obstacle = Obstacles.eyeSwitch;
    data.getCell(3, 9).obstacle = Obstacles.eyeSwitch;
    data.getCell(7, 1).obstacle = Obstacles.royal;

    data.getCell(1, 1).highlight = 'green';
    data.getCell(2, 1).highlight = 'green';
    data.getCell(3, 1).highlight = 'green';
    data.getCell(1, 2).highlight = 'green';
    data.getCell(2, 2).highlight = 'green';
    data.getCell(3, 2).highlight = 'green';
    data.getCell(1, 3).highlight = 'green';
    data.getCell(2, 3).highlight = 'green';
    data.getCell(3, 3).highlight = 'green';
    
    data.getCell(7, 1).highlight = 'blue';
    data.getCell(8, 1).highlight = 'blue';
    data.getCell(9, 1).highlight = 'blue';
    data.getCell(7, 2).highlight = 'blue';
    data.getCell(8, 2).highlight = 'blue';
    data.getCell(9, 2).highlight = 'blue';
    data.getCell(7, 3).highlight = 'blue';
    data.getCell(8, 3).highlight = 'blue';
    data.getCell(9, 3).highlight = 'blue';
    
    data.getCell(1, 7).highlight = 'red';
    data.getCell(2, 7).highlight = 'red';
    data.getCell(3, 7).highlight = 'red';
    data.getCell(1, 8).highlight = 'red';
    data.getCell(2, 8).highlight = 'red';
    data.getCell(3, 8).highlight = 'red';
    data.getCell(1, 9).highlight = 'red';
    data.getCell(2, 9).highlight = 'red';
    data.getCell(3, 9).highlight = 'red';
    
    data.getCell(7, 7).highlight = 'purple';
    data.getCell(8, 7).highlight = 'purple';
    data.getCell(9, 7).highlight = 'purple';
    data.getCell(7, 8).highlight = 'purple';
    data.getCell(8, 8).highlight = 'purple';
    data.getCell(9, 8).highlight = 'purple';
    data.getCell(7, 9).highlight = 'purple';
    data.getCell(8, 9).highlight = 'purple';
    data.getCell(9, 9).highlight = 'purple';
}

export function buildForestTemple() {
    var data = {
        requiredItem: ItemStrings.minuetOfForest,
        sudokuHistory: [buildSudokuData(forestTemplePostProcess, forestTempleGivens)],
        historyStep: 0,
        saveState: buildSudokuData(forestTemplePostProcess, forestTempleGivens),
        solution: forestTempleSolution,
        prizes: ['items.hoverBoots', 'songs.songOfTime', '5 Rupees', 'a Heart Piece', 'songs.boleroOfFire', '50 Rupees', 'songs.requiemOfSpirit', 'a Heart Piece', 'a Gold Skulltula'],
        solvedRegions: [],
        rules: [
            'Standard sudoku rules apply.',
            'The tricky Poe Sisters have rearranged the corner regions. You must place them back into their correct positions to solve the puzzle.'
        ],
        hints: [
            'Don\'t worry about the corner regions at first. Try solving what you can without them.',
            'Once you have a few more clues, you can look for contradictions to narrow down where each corner region should be.'
        ],
        showHint: 0,
        notes: ''
    }

    setForestFunctions(data);
    return data;
}

export function setForestFunctions(data) {
    setDefaultFunctions(data);
    data.setCorner = setCorner;
    data.getCornerColor = getCornerColor;
}

function setCorner(corner, color) {
    var data = _.cloneDeep(this.sudokuHistory[this.historyStep]);
    var newCorner = getCornerIndices(corner);
    var oldCorner = [];
    if(this.getCornerColor('topLeft', data) == color) {
        oldCorner = getCornerIndices('topLeft');
    } else if(this.getCornerColor('topRight', data) == color) {
        oldCorner = getCornerIndices('topRight');
    } else if(this.getCornerColor('bottomLeft', data) == color) {
        oldCorner = getCornerIndices('bottomLeft');
    } else if(this.getCornerColor('bottomRight', data) == color) {
        oldCorner = getCornerIndices('bottomRight');
    }

    for(var i = 0; i < 9; i++) {
        let swap = _.cloneDeep(data.getCell(newCorner[i].col, newCorner[i].row));
        data.cells[(newCorner[i].col-1) + 9*(newCorner[i].row-1)] = _.cloneDeep(data.getCell(oldCorner[i].col, oldCorner[i].row));
        data.cells[(oldCorner[i].col-1) + 9*(oldCorner[i].row-1)] = swap;
    }

    return data;
}

function getCornerColor(corner, data) {
    if(corner == 'topLeft') {
        return data.getCell(1, 1).highlight;
    } else if(corner == 'topRight') {
        return data.getCell(7, 1).highlight;
    } else if(corner == 'bottomLeft') {
        return data.getCell(1, 7).highlight;
    } else if(corner == 'bottomRight') {
        return data.getCell(7, 7).highlight;
    }
}

function getCornerIndices(corner) {
    if(corner == 'topLeft') {
        return [
            {col: 1, row: 1},
            {col: 2, row: 1},
            {col: 3, row: 1},
            {col: 1, row: 2},
            {col: 2, row: 2},
            {col: 3, row: 2},
            {col: 1, row: 3},
            {col: 2, row: 3},
            {col: 3, row: 3}
        ];
    } else if(corner == 'topRight') {
        return [
            {col: 7, row: 1},
            {col: 8, row: 1},
            {col: 9, row: 1},
            {col: 7, row: 2},
            {col: 8, row: 2},
            {col: 9, row: 2},
            {col: 7, row: 3},
            {col: 8, row: 3},
            {col: 9, row: 3}
        ];
    } else 
    if(corner == 'bottomLeft') {
        return [
            {col: 1, row: 7},
            {col: 2, row: 7},
            {col: 3, row: 7},
            {col: 1, row: 8},
            {col: 2, row: 8},
            {col: 3, row: 8},
            {col: 1, row: 9},
            {col: 2, row: 9},
            {col: 3, row: 9}
        ];
    } else if(corner == 'bottomRight') {
        return [
            {col: 7, row: 7},
            {col: 8, row: 7},
            {col: 9, row: 7},
            {col: 7, row: 8},
            {col: 8, row: 8},
            {col: 9, row: 8},
            {col: 7, row: 9},
            {col: 8, row: 9},
            {col: 9, row: 9}
        ];
    }
}

const waterTempleGivens = [
    0, 0, 2, 0, 4, 0, 0, 9, 6, 
    4, 0, 0, 9, 8, 0, 0, 0, 1, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 1, 2, 0, 7, 5, 0, 0, 
    0, 5, 0, 3, 0, 4, 0, 0, 0, 
    2, 3, 0, 5, 0, 0, 0, 0, 0, 
    0, 8, 0, 0, 7, 0, 0, 0, 0, 
    0, 0, 9, 0, 0, 0, 0, 5, 0, 
    0, 0, 3, 0, 0, 6, 4, 0, 0
]

const waterTempleSolution = [
    5, 1, 2, 7, 4, 3, 8, 9, 6, 
    4, 7, 6, 9, 8, 5, 3, 2, 1, 
    3, 9, 8, 6, 2, 1, 7, 4, 5, 
    8, 6, 1, 2, 9, 7, 5, 3, 4, 
    9, 5, 7, 3, 6, 4, 1, 8, 2, 
    2, 3, 4, 5, 1, 8, 9, 6, 7, 
    6, 8, 5, 4, 7, 9, 2, 1, 3, 
    7, 4, 9, 1, 3, 2, 6, 5, 8, 
    1, 2, 3, 8, 5, 6, 4, 7, 9
]

const waterTemplePostProcess = function(data) {
    data.getCell(5, 1).obstacle = Obstacles.underwater;
    data.getCell(4, 2).obstacle = Obstacles.underwater;
    data.getCell(2, 5).obstacle = Obstacles.underwater;
    data.getCell(1, 2).obstacle = Obstacles.hookPoint;
    data.getCell(9, 2).obstacle = Obstacles.hookPoint;

    data.getCell(7, 1).highlight = 'blue';
    data.getCell(8, 1).highlight = 'blue';
    data.getCell(9, 1).highlight = 'blue';
    data.getCell(4, 2).highlight = 'blue';
    data.getCell(5, 2).highlight = 'blue';
    data.getCell(6, 2).highlight = 'blue';
    data.getCell(1, 3).highlight = 'blue';
    data.getCell(2, 3).highlight = 'blue';
    data.getCell(3, 3).highlight = 'blue';
    data.getCell(7, 4).highlight = 'blue';
    data.getCell(8, 4).highlight = 'blue';
    data.getCell(9, 4).highlight = 'blue';
    data.getCell(4, 5).highlight = 'blue';
    data.getCell(5, 5).highlight = 'blue';
    data.getCell(6, 5).highlight = 'blue';
    data.getCell(1, 6).highlight = 'blue';
    data.getCell(2, 6).highlight = 'blue';
    data.getCell(3, 6).highlight = 'blue';
    data.getCell(7, 7).highlight = 'blue';
    data.getCell(8, 7).highlight = 'blue';
    data.getCell(9, 7).highlight = 'blue';
    data.getCell(4, 8).highlight = 'blue';
    data.getCell(5, 8).highlight = 'blue';
    data.getCell(6, 8).highlight = 'blue';
    data.getCell(1, 9).highlight = 'blue';
    data.getCell(2, 9).highlight = 'blue';
    data.getCell(3, 9).highlight = 'blue';
}

export function buildWaterTemple() {
    var data = {
        requiredItem: ItemStrings.serenadeOfWater,
        sudokuHistory: [buildSudokuData(waterTemplePostProcess, waterTempleGivens)],
        historyStep: 0,
        saveState: buildSudokuData(waterTemplePostProcess, waterTempleGivens),
        solution: waterTempleSolution,
        prizes: ['50 Rupees', 'items.hammer', 'a Heart Piece', 'a Gold Skulltula', 'songs.zeldasLullaby', '10 Rupees', 'a Heart Piece', '10 Rupees', '20 Rupees'],
        solvedRegions: [],
        rules: [
            'Standard sudoku rules apply.',
            'The blue cells in a column represent the rising water levels. If a blue cell is higher than another blue cell in the same column, then its value MUST be greater.'
        ],
        hints: [
            'You can eliminate most possibilities in the blue cells using the water level rule.'
        ],
        showHint: 0,
        notes: ''
    }

    setDefaultFunctions(data);
    return data;
}

const childSpiritGivens = [
    0, 0, 4, 0, 5, 0, 0, 0, 8, 
    0, 8, 0, 0, 4, 0, 5, 0, 9, 
    9, 0, 0, 0, 8, 0, 0, 0, 1, 
    0, 0, 0, 0, 0, 4, 0, 6, 2, 
    0, 0, 0, 0, 0, 8, 0, 0, 0, 
    5, 0, 2, 6, 0, 1, 9, 0, 0, 
    0, 0, 0, 0, 0, 3, 0, 0, 0, 
    0, 0, 1, 0, 2, 0, 8, 0, 0, 
    0, 2, 8, 0, 6, 0, 0, 1, 4
]

const childSpiritSolution = [
    2, 1, 4, 7, 5, 9, 6, 3, 8,
    3, 8, 6, 1, 4, 2, 5, 7, 9, 
    9, 5, 7, 3, 8, 6, 2, 4, 1, 
    8, 7, 3, 5, 9, 4, 1, 6, 2, 
    1, 6, 9, 2, 3, 8, 4, 5, 7, 
    5, 4, 2, 6, 7, 1, 9, 8, 3, 
    4, 9, 5, 8, 1, 3, 7, 2, 6, 
    6, 3, 1, 4, 2, 7, 8, 9, 5, 
    7, 2, 8, 9, 6, 5, 3, 1, 4
]

const adultSpiritGivens = [
    0, 0, 0, 0, 5, 0, 0, 7, 2, 
    0, 2, 0, 0, 9, 0, 5, 4, 1, 
    0, 0, 4, 0, 0, 0, 0, 0, 9, 
    0, 3, 6, 0, 2, 0, 0, 1, 0, 
    0, 0, 0, 0, 7, 0, 0, 0, 0, 
    5, 0, 0, 0, 0, 0, 2, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 3, 
    0, 0, 7, 0, 6, 0, 4, 0, 0, 
    0, 6, 1, 0, 0, 0, 0, 9, 7
]

const adultSpiritSolution = [
    6, 9, 8, 1, 5, 4, 3, 7, 2, 
    7, 2, 3, 8, 9, 6, 5, 4, 1, 
    1, 5, 4, 7, 3, 2, 6, 8, 9, 
    4, 3, 6, 5, 2, 9, 7, 1, 8, 
    8, 1, 2, 6, 7, 3, 9, 5, 4, 
    5, 7, 9, 4, 1, 8, 2, 3, 6, 
    9, 4, 5, 2, 8, 7, 1, 6, 3, 
    3, 8, 7, 9, 6, 1, 4, 2, 5, 
    2, 6, 1, 3, 4, 5, 8, 9, 7
]

/* eslint-disable no-unused-vars */
const childSpiritPostProcess = function(data) {
    setSpiritHighlights(data);
}

const adultSpiritPostProcess = function(data) {
    data.getCell(8, 1).obstacle = Obstacles.pillar;
    data.getCell(3, 4).obstacle = Obstacles.sunSpot;
    setSpiritHighlights(data);
}

const setSpiritHighlights = function(data) {
    data.getCell(4, 1).highlight = "orange";
    data.getCell(4, 2).highlight = "orange";
    data.getCell(4, 3).highlight = "orange";
    data.getCell(5, 1).highlight = "orange";
    data.getCell(5, 2).highlight = "orange";
    data.getCell(5, 3).highlight = "orange";
    data.getCell(6, 1).highlight = "orange";
    data.getCell(6, 2).highlight = "orange";
    data.getCell(6, 3).highlight = "orange";
    
    data.getCell(1, 4).highlight = "orange";
    data.getCell(1, 5).highlight = "orange";
    data.getCell(1, 6).highlight = "orange";
    data.getCell(2, 4).highlight = "orange";
    data.getCell(2, 5).highlight = "orange";
    data.getCell(2, 6).highlight = "orange";
    data.getCell(3, 4).highlight = "orange";
    data.getCell(3, 5).highlight = "orange";
    data.getCell(3, 6).highlight = "orange";
    
    data.getCell(7, 4).highlight = "orange";
    data.getCell(7, 5).highlight = "orange";
    data.getCell(7, 6).highlight = "orange";
    data.getCell(8, 4).highlight = "orange";
    data.getCell(8, 5).highlight = "orange";
    data.getCell(8, 6).highlight = "orange";
    data.getCell(9, 4).highlight = "orange";
    data.getCell(9, 5).highlight = "orange";
    data.getCell(9, 6).highlight = "orange";
    
    data.getCell(4, 7).highlight = "orange";
    data.getCell(4, 8).highlight = "orange";
    data.getCell(4, 9).highlight = "orange";
    data.getCell(5, 7).highlight = "orange";
    data.getCell(5, 8).highlight = "orange";
    data.getCell(5, 9).highlight = "orange";
    data.getCell(6, 7).highlight = "orange";
    data.getCell(6, 8).highlight = "orange";
    data.getCell(6, 9).highlight = "orange";
    
}

export function buildSpiritTemple() {
    return {
        requiredItem: ItemStrings.requiemOfSpirit,
        sudokuHistory: [{
            childData: buildSudokuData(childSpiritPostProcess, childSpiritGivens),
            adultData: buildSudokuData(adultSpiritPostProcess, adultSpiritGivens)
        }],
        historyStep: 0,
        saveState: {
            childData: buildSudokuData(childSpiritPostProcess, childSpiritGivens),
            adultData: buildSudokuData(adultSpiritPostProcess, adultSpiritGivens)
        },
        childSolution: childSpiritSolution,
        adultSolution: adultSpiritSolution,
        prizes: ['100 Rupees','a Gold Skulltula','items.lensOfTruth','a Heart Piece','20 Rupees','items.goronTunic','5 Rupees','a Gold Skulltula','items.bombs'],
        solvedRegions: [],
        rules: [
            'Standard sudoku rules apply.',
            'You must navigate the Spirit Temple as both a child and adult. However, the temple has changed over time - any squares that were a 1, 2, 3, or 4 as a child are now a 6, 7, 8, or 9 as an adult.',
            'The 5s are in the same locations for both child and adult.',
            'To open a chest, you must solve the same region as both a child and adult.'
        ],
        hints: [
            'Remember that the inverse of the rule is also true - anything that is a 6, 7, 8, or 9 as child will be a 1, 2, 3, or 4 as adult.',
        ],
        showHint: 0,
        notes: ''
    }
}

export function setSpiritFunctions(data) {
    data.applyChanges = applyChanges;
    data.undo = undo;
    data.redo = redo;
    data.setSaveState = setSaveState;
    data.restoreSaveState = restoreSaveState;
    data.checkSolvedCell = checkSpiritSolvedCell;
    data.checkSolvedRegions = checkSolvedRegions;
    data.awardPrize = awardPrize;
    data.showNextHint = showNextHint;
    data.resetInitialState = resetInitialState;
    data.clearSelections = clearSpiritSelections;
    data.getRegionCells = getSpiritRegionCells;
}

export function setSpiritDataFunctions(data) {
    for(var i = 0; i < data.sudokuHistory.length; i++) {
        setDataFunctions(data.sudokuHistory[i].childData)
        setDataFunctions(data.sudokuHistory[i].adultData)
    }
    setDataFunctions(data.saveState.childData);
    setDataFunctions(data.saveState.adultData);
}

function showNextHint() {
    if(this.showHint < this.hints.length) {
        this.showHint += 1;
    }
}

function applyChanges(newData, awardFunc) {
    this.clearSelections();
    this.sudokuHistory = _.takeRight(this.sudokuHistory, 50);
    this.sudokuHistory.push(newData);
    this.historyStep = this.sudokuHistory.length - 1;
    this.checkSolvedRegions(awardFunc);
    return this;
}

function clearSelections() {
    var data = this.sudokuHistory[this.historyStep];
    data.cells.forEach(cell => {
        cell.isSelected = false;
    });
}

function clearSpiritSelections() {
    var data = this.sudokuHistory[this.historyStep];
    data.childData.cells.forEach(cell => {
        cell.isSelected = false;
    });
    data.adultData.cells.forEach(cell => {
        cell.isSelected = false;
    });
}

function undo(saveData) {
    if(this.historyStep > 0) {
        this.historyStep--;
        this.clearSelections();
        if(saveData) saveData();
    }
}

function redo(saveData) {
    if(this.historyStep < this.sudokuHistory.length - 1) {
        this.historyStep++;
        this.clearSelections();
        if(saveData) saveData();
    }
}

function setSaveState(saveData) {
    this.saveState = _.cloneDeep(this.sudokuHistory[this.historyStep]);
    if(saveData) saveData();
}

function restoreSaveState(saveData) {
    this.applyChanges(this.saveState);
    this.clearSelections();
    if(saveData) saveData();
}

function checkSolvedCell(col, row) {
    const data = this.sudokuHistory[this.historyStep];
    const solutionValue = this.solution[(col-1) + 9*(row - 1)];
    var cell = data.getCell(col, row);
    return !cell.obstacle && cell.number == solutionValue;
}

function checkSpiritSolvedCell(col, row) {
    const data = this.sudokuHistory[this.historyStep];
    const childSolutionValue = this.childSolution[(col-1) + 9*(row - 1)];
    const adultSolutionValue = this.adultSolution[(col-1) + 9*(row - 1)];
    var childCell = data.childData.getCell(col, row);
    var adultCell = data.adultData.getCell(col, row);
    return  !childCell.obstacle && childCell.number == childSolutionValue &&
            !adultCell.obstacle && adultCell.number == adultSolutionValue;
}

function getRegionCells(region) {
    const data = this.sudokuHistory[this.historyStep];
    return getDataRegionCells(data, region);
}

function getSpiritRegionCells(region) {
    const data = this.sudokuHistory[this.historyStep];
    var cells = getDataRegionCells(data.childData, region);
    cells = cells.concat(getDataRegionCells(data.adultData, region));
    return cells;
}

function getDataRegionCells(data, region) {
    if(region == 1) {
        return [data.getCell(1, 1), data.getCell(2, 1), data.getCell(3, 1), 
                data.getCell(1, 2), data.getCell(2, 2), data.getCell(3, 2),
                data.getCell(1, 3), data.getCell(2, 3), data.getCell(3, 3)];
    } else if(region == 2) {
        return [data.getCell(4, 1), data.getCell(5, 1), data.getCell(6, 1), 
                data.getCell(4, 2), data.getCell(5, 2), data.getCell(6, 2),
                data.getCell(4, 3), data.getCell(5, 3), data.getCell(6, 3)];
    } else if(region == 3) {
        return [data.getCell(7, 1), data.getCell(8, 1), data.getCell(9, 1), 
                data.getCell(7, 2), data.getCell(8, 2), data.getCell(9, 2),
                data.getCell(7, 3), data.getCell(8, 3), data.getCell(9, 3)];
    } else if(region == 4) {
        return [data.getCell(1, 4), data.getCell(2, 4), data.getCell(3, 4), 
                data.getCell(1, 5), data.getCell(2, 5), data.getCell(3, 5),
                data.getCell(1, 6), data.getCell(2, 6), data.getCell(3, 6)];
    } else if(region == 5) {
        return [data.getCell(4, 4), data.getCell(5, 4), data.getCell(6, 4), 
                data.getCell(4, 5), data.getCell(5, 5), data.getCell(6, 5),
                data.getCell(4, 6), data.getCell(5, 6), data.getCell(6, 6)];
    } else if(region == 6) {
        return [data.getCell(7, 4), data.getCell(8, 4), data.getCell(9, 4), 
                data.getCell(7, 5), data.getCell(8, 5), data.getCell(9, 5),
                data.getCell(7, 6), data.getCell(8, 6), data.getCell(9, 6)];
    } else if(region == 7) {
        return [data.getCell(1, 7), data.getCell(2, 7), data.getCell(3, 7), 
                data.getCell(1, 8), data.getCell(2, 8), data.getCell(3, 8),
                data.getCell(1, 9), data.getCell(2, 9), data.getCell(3, 9)];
    } else if(region == 8) {
        return [data.getCell(4, 7), data.getCell(5, 7), data.getCell(6, 7), 
                data.getCell(4, 8), data.getCell(5, 8), data.getCell(6, 8),
                data.getCell(4, 9), data.getCell(5, 9), data.getCell(6, 9)];
    } else if(region == 9) {
        return [data.getCell(7, 7), data.getCell(8, 7), data.getCell(9, 7), 
                data.getCell(7, 8), data.getCell(8, 8), data.getCell(9, 8),
                data.getCell(7, 9), data.getCell(8, 9), data.getCell(9, 9)];
    }
}

function checkSolvedRegions(awardFunc) {
    if( this.checkSolvedCell(1, 1) &&
        this.checkSolvedCell(2, 1) &&
        this.checkSolvedCell(3, 1) &&
        this.checkSolvedCell(1, 2) &&
        this.checkSolvedCell(2, 2) &&
        this.checkSolvedCell(3, 2) &&
        this.checkSolvedCell(1, 3) &&
        this.checkSolvedCell(2, 3) &&
        this.checkSolvedCell(3, 3) ) {
            if(this.solvedRegions.indexOf(1) == -1) {
                this.awardPrize(1, awardFunc);
            }
            this.getRegionCells(1).forEach(c => {c.textHighlight = "greenText"; c.isCompleted = true;});
        }
    if( this.checkSolvedCell(4, 1) &&
        this.checkSolvedCell(5, 1) &&
        this.checkSolvedCell(6, 1) &&
        this.checkSolvedCell(4, 2) &&
        this.checkSolvedCell(5, 2) &&
        this.checkSolvedCell(6, 2) &&
        this.checkSolvedCell(4, 3) &&
        this.checkSolvedCell(5, 3) &&
        this.checkSolvedCell(6, 3) ) {
            if(this.solvedRegions.indexOf(2) == -1) {
                this.awardPrize(2, awardFunc);
            }
            this.getRegionCells(2).forEach(c => {c.textHighlight = "greenText"; c.isCompleted = true;});
        }
    if( this.checkSolvedCell(7, 1) &&
        this.checkSolvedCell(8, 1) &&
        this.checkSolvedCell(9, 1) &&
        this.checkSolvedCell(7, 2) &&
        this.checkSolvedCell(8, 2) &&
        this.checkSolvedCell(9, 2) &&
        this.checkSolvedCell(7, 3) &&
        this.checkSolvedCell(8, 3) &&
        this.checkSolvedCell(9, 3) ) {
            if(this.solvedRegions.indexOf(3) == -1) {
                this.awardPrize(3, awardFunc);
            }
            this.getRegionCells(3).forEach(c => {c.textHighlight = "greenText"; c.isCompleted = true;});
        }
    if( this.checkSolvedCell(1, 4) &&
        this.checkSolvedCell(2, 4) &&
        this.checkSolvedCell(3, 4) &&
        this.checkSolvedCell(1, 5) &&
        this.checkSolvedCell(2, 5) &&
        this.checkSolvedCell(3, 5) &&
        this.checkSolvedCell(1, 6) &&
        this.checkSolvedCell(2, 6) &&
        this.checkSolvedCell(3, 6) ) {
            if(this.solvedRegions.indexOf(4) == -1) {
                this.awardPrize(4, awardFunc);
            }
            this.getRegionCells(4).forEach(c => {c.textHighlight = "greenText"; c.isCompleted = true;});
        }
    if( this.checkSolvedCell(4, 4) &&
        this.checkSolvedCell(5, 4) &&
        this.checkSolvedCell(6, 4) &&
        this.checkSolvedCell(4, 5) &&
        this.checkSolvedCell(5, 5) &&
        this.checkSolvedCell(6, 5) &&
        this.checkSolvedCell(4, 6) &&
        this.checkSolvedCell(5, 6) &&
        this.checkSolvedCell(6, 6) ) {
            if(this.solvedRegions.indexOf(5) == -1) {
                this.awardPrize(5, awardFunc);
            }
            this.getRegionCells(5).forEach(c => {c.textHighlight = "greenText"; c.isCompleted = true;});
        }
    if( this.checkSolvedCell(7, 4) &&
        this.checkSolvedCell(8, 4) &&
        this.checkSolvedCell(9, 4) &&
        this.checkSolvedCell(7, 5) &&
        this.checkSolvedCell(8, 5) &&
        this.checkSolvedCell(9, 5) &&
        this.checkSolvedCell(7, 6) &&
        this.checkSolvedCell(8, 6) &&
        this.checkSolvedCell(9, 6) ) {
            if(this.solvedRegions.indexOf(6) == -1) {
                this.awardPrize(6, awardFunc);
            }
            this.getRegionCells(6).forEach(c => {c.textHighlight = "greenText"; c.isCompleted = true;});
        }
    if( this.checkSolvedCell(1, 7) &&
        this.checkSolvedCell(2, 7) &&
        this.checkSolvedCell(3, 7) &&
        this.checkSolvedCell(1, 8) &&
        this.checkSolvedCell(2, 8) &&
        this.checkSolvedCell(3, 8) &&
        this.checkSolvedCell(1, 9) &&
        this.checkSolvedCell(2, 9) &&
        this.checkSolvedCell(3, 9) ) {
            if(this.solvedRegions.indexOf(7) == -1) {
                this.awardPrize(7, awardFunc);
            }
            this.getRegionCells(7).forEach(c => {c.textHighlight = "greenText"; c.isCompleted = true;});
        }
    if( this.checkSolvedCell(4, 7) &&
        this.checkSolvedCell(5, 7) &&
        this.checkSolvedCell(6, 7) &&
        this.checkSolvedCell(4, 8) &&
        this.checkSolvedCell(5, 8) &&
        this.checkSolvedCell(6, 8) &&
        this.checkSolvedCell(4, 9) &&
        this.checkSolvedCell(5, 9) &&
        this.checkSolvedCell(6, 9) ) {
            if(this.solvedRegions.indexOf(8) == -1) {
                this.awardPrize(8, awardFunc);
            }
            this.getRegionCells(8).forEach(c => {c.textHighlight = "greenText"; c.isCompleted = true;});
        }
    if( this.checkSolvedCell(7, 7) &&
        this.checkSolvedCell(8, 7) &&
        this.checkSolvedCell(9, 7) &&
        this.checkSolvedCell(7, 8) &&
        this.checkSolvedCell(8, 8) &&
        this.checkSolvedCell(9, 8) &&
        this.checkSolvedCell(7, 9) &&
        this.checkSolvedCell(8, 9) &&
        this.checkSolvedCell(9, 9) ) {
            if(this.solvedRegions.indexOf(9) == -1) {
                this.awardPrize(9, awardFunc);
            }
            this.getRegionCells(9).forEach(c => {c.textHighlight = "greenText"; c.isCompleted = true;});
        }
}

function awardPrize(number, awardFunc) {
    /* eslint-disable no-undef */
    gtag('event', 'solved', {
        'event_category' : 'sudoku',
        'event_label' : window.location.hash + '/' + number,
        'value': number
    });
    this.solvedRegions.push(number);
    
    awardFunc(this.prizes[number - 1], number);
}

function resetInitialState() {
    const currentStep = this.sudokuHistory[this.historyStep];
    this.sudokuHistory = [currentStep];
    this.historyStep = 0;
    this.setSaveState();
}